import React from 'react'
import { Box, styled, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import ToggleSwitch from '@app/components/ui/inputs/ToggleSwitch'

type Props = {
  icon: IconDefinition
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}

const ToolsMenuItem: React.FC<Props> = ({ icon, label, checked, onChange }) => {
  const labelId = `tools-menu-${label.toLowerCase().replace(/\s+/g, '-')}`

  return (
    <StyledContainer>
      <TextContainer>
        <IconContainer>
          <Icon icon={icon} />
        </IconContainer>
        {/* a11y: name the switch from this label (single announcement); the label
            text is aria-hidden so it isn't also read as standalone content */}
        <Typography id={labelId} aria-hidden variant='body1'>
          {label}
        </Typography>
      </TextContainer>
      <ToggleSwitch
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        inputProps={{ 'aria-labelledby': labelId }}
      />
    </StyledContainer>
  )
}

export default ToolsMenuItem

const IconContainer = styled(Box)(({ theme }) => ({
  width: theme.typography.pxToRem(16),
  height: theme.typography.pxToRem(16),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 5),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

const TextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'center',
}))

export const Icon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.additionalColors['bg_500'],
}))
